import React, {Component} from 'react';
import Header from '../header/header';
import {
    Row,
    Col,
} from 'reactstrap';

import Footer from '../statics/footer';
import './video.css'

import InfoChat from '../chat/info_chat';
import TelaVideo from './tela_video';

export default class Video extends Component{
    constructor(){
        super();
        this.state={convidado:{nome:'Joelma Maia', categoria:'Pequenas empresas'}}
        
    }
    render(){
        return(
            <div id='video-page'>
                {/* <Header /> */}
                <div>
                    <Row className='video-container'>
                        <Col md="4" lg="3" className="info_chat">
                            <InfoChat/>
                        </Col>
                        <TelaVideo/>
                    </Row>

                </div>
                <Footer/>
            </div>

        )
    }
}